import axios from "axios";
import { ApiBaseUrl, ApiBaseUrlV2 } from "./constants";
import { getAuthHeaderToken, clearAuth } from "./authStorage";
import { toErrorMessage } from "./errorMessage";

const createClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
  });

  client.interceptors.request.use((config) => {
    const requireUser = Boolean(config.requireUser);
    const skipAuth = Boolean(config.skipAuth);
    delete config.requireUser;
    delete config.skipAuth;
    if (!skipAuth) {
      const token = getAuthHeaderToken(requireUser);
      if (token) {
        // Backend expects raw JWT — no "Bearer " prefix
        config.headers.authorization = token;
      }
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const data = error?.response?.data || {};
      if (status === 401) {
        clearAuth();
      }
      return Promise.reject({
        message: toErrorMessage(
          { message: data.message, data, _message: data._message },
          error?.message || "Something went wrong"
        ),
        status,
        data,
        raw: error,
      });
    }
  );

  return client;
};

export const api = createClient(ApiBaseUrl);
export const apiV2 = createClient(ApiBaseUrlV2);

export const unwrap = (response) => {
  const body = response?.data;
  if (body && body.status === 0) {
    const err = new Error(
      toErrorMessage(body, body.message || "Request failed")
    );
    err.data = body;
    err.status = 0;
    throw err;
  }
  return body;
};
